var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expand-transition',[_c('v-alert',{attrs:{"color":_vm.color,"icon":_vm.icon,"dark":_vm.color == 'primary',"dismissible":"","elevation":"5"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }